export default __webpack_public_path__ + "static/media/assistant.716ff8c7.png";